const $ = jQuery;

export default {
	init() {
		setupWrapperClasses();
	}
}

function setupWrapperClasses() {
	$(document).on('lazyloaded', '.lazyload-wrapper', loaded);
}

function loaded(e) {
	$(this).closest('.lazyload-wrapper').addClass('loaded');
	$(this).trigger('lazyloaded-image', e);
}